import {Checkbox, Menu, Tab} from "semantic-ui-react";
import {TabTable} from "./Table";
import {CompanyHeader} from "./CompanyHeader";
import {useState} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {useTranslation} from "react-i18next";
const style = {
  tabpane: {
    height: "calc(100vh - 57px)",
    padding: "7px 0px 0px 0px",
  },
};

export const CompanyData = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const tags = useSelector((state: RootState) => state.refData.allTags);
  const {dpiValues, labelSizes, employees} = useSelector((state: RootState) => state.refData);
  const {invent, counterData, printData} = useSelector((state: RootState) => state.companyData);
  const {t} = useTranslation();

  const LLLabelSizeColumns = [
    {headerName: t("name"), field: "name", flex: 2},
    {headerName: t("width"), field: "width", flex: 1},
    {headerName: t("height"), field: "height", flex: 1},
  ];

  const LLTagTableColumns = [
    {headerName: "Id", field: "id", flex: 1, lockPosition: true},
    {headerName: t("name"), field: "name", flex: 1.5, lockPosition: true},
    {headerName: t("default_text"), field: "defaulttext", flex: 1.7, lockPosition: true},
    {
      headerName: t("text_tag"),
      field: "istexttag",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("barcode_tag"),
      field: "isbarcodetag",
      flex: 1.1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("image_tag"),
      field: "isimgtag",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("tech_tag"),
      field: "istechtag",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("is_primary"),
      field: "isprimary",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("is_gs1_ai"),
      field: "isgs1ai",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("use_counter"),
      field: "usecounter",
      flex: 1.1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {
      headerName: t("is_required"),
      field: "isrequired",
      flex: 1,
      lockPosition: true,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
  ];

  const LLDpiColumns = [{headerName: "DPI", field: "dpi", flex: 1, lockPosition: true}];

  const LLEmployeeColumns = [
    {headerName: t("email2"), field: "email", flex: 1, filter: "agTextColumnFilter"},
    {headerName: t("role"), field: "roleId", flex: 1, filter: "agTextColumnFilter", cellRenderer: (params: any) => t(params.value)},
  ];

  const InventTableColumns = [
    {headerName: t("itemid"), field: "itemId", flex: 1, minWidth: 140},
    {headerName: t("itemname"), field: "itemName", flex: 2, minWidth: 200},
    {headerName: t("ean14_pcs_table"), field: "ean14", flex: 2, minWidth: 200},
    {headerName: t("ean14_box_table"), field: "ean14Box", flex: 2, minWidth: 200},
    {headerName: t("ean14_pallet_table"), field: "ean14Pallet", flex: 2, minWidth: 210},
    {headerName: t("qty_box"), field: "qtyBox", flex: 1, minWidth: 150},
    {headerName: t("qty_pallet"), field: "qtyPallet", flex: 1, minWidth: 160},
    {headerName: t("net_weight_pcs"), field: "netWeight", flex: 2, minWidth: 200},
    {headerName: t("brutto_weight_pcs"), field: "bruttoWeight", flex: 1.5, minWidth: 180},
    {headerName: t("brutto_weight_box"), field: "bruttoWeightBox", flex: 1.5, minWidth: 190},
    {headerName: t("brutto_weight_pallet"), field: "bruttoWeightPallet", flex: 2, minWidth: 200},
    {headerName: t("best_before"), field: "daysBb", flex: 1, minWidth: 140},
    {headerName: t("expiry"), field: "daysExp", flex: 1, minWidth: 150},
    {headerName: "AI 90", field: "ai90", flex: 1, minWidth: 100},
    {headerName: "AI 91", field: "ai91", flex: 1, minWidth: 100},
    {headerName: "AI 92", field: "ai92", flex: 1, minWidth: 100},
    {headerName: t("other_info"), field: "other", flex: 3, minWidth: 300},
  ];

  const CounterTableColumns = [
    {headerName: t("counter"), field: "name", flex: 1},
    {
      headerName: t("is_sscc"),
      field: "isSscc",
      flex: 1,
      cellRenderer: (params: any) => {
        return <Checkbox type="checkbox" checked={params.value === 1} readOnly />;
      },
    },
    {headerName: t("length"), field: "len", flex: 1},
    {headerName: t("prefix"), field: "prefix", flex: 1},
    {headerName: t("next_value"), field: "nextValue", flex: 1},
  ];

  const PrintTableColumns = [
    {headerName: "Id", field: "id", flex: 0.5, hide: true},
    {headerName: t("template"), field: "template", flex: 1},
    {headerName: "SSCC", field: "sscc", flex: 1},
    {headerName: t("itemid"), field: "itemId", flex: 0.7},
    {headerName: "EAN14", field: "ean14", flex: 1},
    {
      headerName: t("print_date"),
      field: "printDt",
      flex: 1,
      filter: "agDateColumnFilter",
      cellRenderer: (params: any) => {
        return params.value ? new Date(params.value).toLocaleString("LT") : "";
      },
    },
    {headerName: t("printed_by_user"), field: "printBy", flex: 1},
  ];

  const panes = [
    {
      menuItem: t("tag_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="tags" columns={LLTagTableColumns} rowData={tags} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("dpi_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="dpi" columns={LLDpiColumns} rowData={dpiValues} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("labelsize_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="labelSize" columns={LLLabelSizeColumns} rowData={labelSizes} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("users_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="employees" columns={LLEmployeeColumns} rowData={employees} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("invent_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="inventtable" columns={InventTableColumns} rowData={invent} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("counter_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="countertable" columns={CounterTableColumns} rowData={counterData} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("print_table"),
      render: () => (
        <Tab.Pane style={style.tabpane}>
          <TabTable gridName="printtable" columns={PrintTableColumns} rowData={printData} />
        </Tab.Pane>
      ),
    },
  ];

  const renderMenuItems = () =>
    panes.map((pane, index) => <Menu.Item key={index} style={{padding: "7px 20px"}} content={pane.menuItem} active={activeIndex === index} onClick={() => setActiveIndex(index)} />);
  const renderActiveTab = () => panes[activeIndex].render();
  return (
    <>
      <CompanyHeader>
        <Menu tabular style={{marginBottom: -2, marginTop: 0}} className="tab-menu">
          {renderMenuItems()}
        </Menu>
      </CompanyHeader>
      {renderActiveTab()}
    </>
  );
};
